/* eslint-disable react/jsx-props-no-spreading */
import {
    useCallback,
} from 'react'
import noop from 'lodash/noop'

import FormWithControls from 'app/shared-components/FormWithControls'

import config from 'app/requests/ContainerNote.requests'

import useStyles from './CreateContainerNote.styles'
import fields from './CreateContainerNote.fields'

type Props = {
    name: string,
    id: number,
    objectName?: string,
    isNew?: boolean,
    onCancel?: () => void,
    onSuccess?: () => void,
}

const defaultProps: Partial<Props> = {
    isNew: false,
    onCancel: noop,
    objectName: 'Container',
    onSuccess: noop,
}

const CreateContainerNote = (props: Props) => {
    const {
        classes,
    } = useStyles()

    const {
        name,
        id,
        objectName,
        isNew,
        onCancel,
        onSuccess,
    } = props

    const onSuccessAdded = useCallback(() => {
        onSuccess()
        onCancel()
    }, [
        onCancel,
        onSuccess,
    ])

    return (
        <FormWithControls
            {...props}
            name={name}
            value={{
                containerId: id,
                objectName,
                noteType: 'NOTE',
                systemId: 'SKYNET',
            }}
            className={classes.rowFormContainer}
            classNames={{
                gridWrapper: classes.gridWrapper,
                gridCardWrapper: classes.gridCardWrapper,
            }}
            requestParams={config.create()}
            fields={fields}
            exists={!isNew}
            cancelEnabled={isNew}
            onSuccess={onSuccessAdded}
            onCancel={onCancel}
        />
    )
}

CreateContainerNote.defaultProps = defaultProps

export default CreateContainerNote
